<!-- form panel -->

<header>
    <div class="dropdown">
        <button id="print-center-actions" class="btn btn-primary dropdown-toggle dropdown-toggle-split"
            type="button" data-toggle="dropdown" aria-expanded="false">
            <span class="uil uil-print"></span>
        </button>
        <div class="dropdown-menu">
            <div class="dropdown-item" href="#" (click)="bulk($event)">Print/Download All</div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" href="#" (click)="zeroCopies($event)">Zero out copies</div>
            <div class="dropdown-item" href="#" (click)="resetCopies($event)">Reset copy counts</div>
        </div>
    </div>
</header>

<div class="row">
    <div class="col">
        <div class="card-columns">
            @for (group of groupKeys; track group) {
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{group | titlecase}} Documents</h4>
                        <ul class="list-group list-group-flush">
                            @for (form of formKeys(group); track form) {
                            <li class="list-group-item clickable">
                                <input type="number" class="form-control form-control-sm text-center" [id]="group + '-' + form + '-copies'" name="copies" [value]="copies(group, form)" (change)="changed($event, group, form)" />
                                <p (click)="view(group, form)" [title]="revision(group, form)">{{form}}</p>
                                @if (formOptionCount(group, form) > 1) {
                                    <select class="custom-select form-control form-control-sm" [id]="'form-option-index-' + form" (change)="optionChanged($event, group, form)">
                                        @for (formOption of formOptions(group, form); track formOption; let i = $index) {
                                            <option [value]="formOption.id" [attr.data-i]="i">{{formOption.producer}} ({{formOption.revision}})</option>
                                        }
                                    </select>
                                }
                                @if (allowSetupValueChanges(group, form)) {
                                    <div class="actions">
                                        <button class="btn btn-sm btn-outline-primary" (click)="openModal(group, form)"><span class="uil-cog"></span></button>
                                    </div>
                                }
                            </li>
                            }
                        </ul>
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<!-- Pdf View Modal -->
<button id="btn-view-pdf-modal" data-target="#pdfViewModal" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="pdfViewModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="pdfViewModal">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Forms</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body p-1">
                @if (isManaged) {
                <ul class="list-group list-group-horizontal align-items-center">
                    <li class="list-group-item border-0 p-1">
                        <label for="incrementByInches" class="col-form-label">Increment By (inches)</label>
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <input type="email" class="form-control col-6" id="incrementByInches" placeholder="1"
                            [value]=".10">
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <a href="javascript:void(0);"
                            class="link-info text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                            (click)="adjustCoordinates('left')">Move Left</a>
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <a href="javascript:void(0);"
                            class="link-info text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                            (click)="adjustCoordinates('right')">Move Right</a>
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <a href="javascript:void(0);"
                            class="link-info text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                            (click)="adjustCoordinates('up')">Move Up</a>
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <a href="javascript:void(0);"
                            class="link-info text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                            (click)="adjustCoordinates('down')">Move Down</a>
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <a href="javascript:void(0);"
                            class="link-info text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                            (click)="adjustCoordinates('reset')">Reset to Master Defaults</a>
                    </li>
                    <li class="list-group-item border-0 p-1">
                        <a href="javascript:void(0);"
                            class="link-info text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                            (click)="saveCoordinates()">Save Current Coordinates as Defaults</a>
                    </li>
                </ul>
                }
                @if (pdf) {
                <object type="application/pdf" [data]="pdf" width="100%" height="90%"></object>
                }
                @else {
                <div class="waiting">
                    <div class="spinner-grow text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>

<button id="btn-view-dynamicSetupForm-modal" data-target="#dynamicSetupForm" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="dynamicSetupForm" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="dynamicSetupForm">
    <dynamic-setup-form [setupValues]="setupValuesString" [selectedForm]="selectedForm" [saleId]="saleId"></dynamic-setup-form>
</div>